module.exports = __webpack_public_path__ + "img/qr-link.f8c531c3.svg";